export default "__VITE_ASSET__sDB9SxXj__"